/* 全局方法 - 仅客户端 */
import _ from 'lodash'
import { bucketCdnHost, bucketHost } from '~/utils/common'

/**
 * 按需加载 PDF 导出功能
 * 避免在首页加载时立即加载 jsPDF 相关依赖
 */
async function lazyExportPDF(containerId: string): Promise<string> {
  if (!process.client) {
    console.warn('PDF export is only available on client side')
    return Promise.resolve('')
  }

  try {
    console.log('开始按需加载 PDF 导出功能...')

    // 动态导入 PDF 导出模块，只在实际需要时才加载
    const { exportPDFWithHeader } = await import('~/utils/pdf-export-with-header')
    return await exportPDFWithHeader(containerId)
  } catch (error) {
    console.error('Failed to load PDF export module:', error)
    throw error
  }
}



export default defineNuxtPlugin({
  name: 'v-counter-client',
  setup(nuxtApp) {
    // 注册按需加载的 PDF 导出方法
    nuxtApp.vueApp.config.globalProperties.exportPDF = lazyExportPDF

    console.log('PDF 导出插件已注册（按需加载模式）')
  }
})